const HERO_IMAGE_SELECTIONS = {
  "Hero 1": "heroImage",
  "Hero 2": "heroImageTwo",
  "Hero 3": "heroImageThree"
}

const pickFirstAvailableHeroImage = ({
  heroImage,
  heroImageTwo,
  heroImageThree
}) => heroImage || heroImageTwo || heroImageThree || null

const resolveHeroImageBySelection = (
  images = {},
  selection,
  { allowUnset = false, fallback = null } = {}
) => {
  if (allowUnset && selection === "Unset") {
    return fallback
  }

  const key = HERO_IMAGE_SELECTIONS[selection]

  if (key && images[key]) {
    return images[key]
  }

  return fallback || pickFirstAvailableHeroImage(images)
}

export { resolveHeroImageBySelection, pickFirstAvailableHeroImage }
